module.exports = __webpack_public_path__ + "img/icon3.926c6b54.png";